module.exports = __webpack_public_path__ + "static/media/spin-wheel-border.aaf3b99d.png";